export default __webpack_public_path__ + "static/blob-31-e829623f6006c50e3dad6380623f5dee.svg";